import { round } from "lodash";

export default function addScore(a, b) {
	a = a.split("/");
	b = b.split("/");
	a[0] = round(parseFloat(a[0]) + parseFloat(b[0]), 1);
	a[1] = round(parseFloat(a[1]) + parseFloat(b[1]), 1);
	return a.join("/");
}
